import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from '@reducers/interfaces';
import { parseDate } from '@shiftbase-com/ts-shared/utilities';
import { map } from 'rxjs/operators';

import { selectAuthUserId } from '../../../reducers/auth/auth.selectors';
import { getSelectedMyScheduleDate } from '../../../reducers/page-filters/page-filters.helper';
import { lazySelect } from '../../../shared/lazy-select.observable';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
  selector: 'my-schedule',
  template: `
    <personal-schedule
      [date]="date | async"
      [employeeId]="employeeId$ | async"
      (changeDateEmitter)="changeDate($event)"
    ></personal-schedule>
  `,
})
export class MyScheduleComponent {
  #store = inject<Store<AppState>>(Store);
  #router = inject(Router);
  #route = inject(ActivatedRoute);

  employeeId$ = this.#store.pipe(lazySelect(selectAuthUserId));

  date = this.#store.pipe(
    lazySelect(getSelectedMyScheduleDate),
    map((date) => parseDate(date)),
  );

  /**
   * Navigates relative to the active route. The matrix param change re-runs
   * MyScheduleDateResolver, which loads the period.
   */
  changeDate(date: string): void {
    this.#router.navigate([{ date }], { relativeTo: this.#route });
  }
}
